import { render, staticRenderFns } from "./AffiliateInvitationModal.vue?vue&type=template&id=505d5d0b&"
import script from "./AffiliateInvitationModal.vue?vue&type=script&lang=js&"
export * from "./AffiliateInvitationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports